import type { LogLevel, LogCategory } from '@/services/logger'

export enum AdminAccessLevel {
    NONE = 'none',
    NORMAL = 'normal',
    GOD = 'god'
}

export interface SecurityLogEntry {
    id: string
    timestamp: string // ISO string for storage
    level: LogLevel
    category: LogCategory
    message: string
    isPermanent: boolean // Never auto-delete
    syncStatus: 'pending' | 'synced' | 'failed'
    syncAttempts: number
    failureType:
        | 'invalid_qr'
        | 'expired_qr'
        | 'replay_attempt'
        | 'geofence_failure'
        | 'repeated_failure'
    context?: {
        workerId?: number
        location?: { lat: number; lng: number }
        qrPayload?: { timestamp: string; noonce?: string } // Sanitized (no sensitive data)
        failureReason: string
        attemptCount?: number
    }
    isSuspicious?: boolean
    workerId?: number
}

export interface AdminLogEntry {
    id: string
    timestamp: string // ISO string for storage
    level: LogLevel
    category: LogCategory
    message: string
    isSuspicious?: boolean
    workerId?: number
    context?: Record<string, unknown>
}

export interface SecurityLogExport {
    exportDate: string
    totalLogs: number
    logs: SecurityLogEntry[]
}

export interface SecurityLogFilter {
    failureType?: string
    startDate?: string
    endDate?: string
    workerId?: number
}
